'use client'
import React, { PropsWithChildren } from 'react'
import styles from './styles.module.scss'

const Head: React.FC<PropsWithChildren> = props => {
  return <thead {...props} className={styles.head} />
}

export default Head
